import _ from 'lodash'
import { utils as tkUtils } from '@adc/ui-core'
const { formatTitleCase } = tkUtils.formatters

/*
 * Retrieve key values from an Array of Objects
 * @params data Array array to filter through each object
 * example: [ {id: 2, 'created_by': 1222 }]
 * @params keys Array the keys to look for in the data array per object
 * example: ['created_by', 'updated_by']
 * @returns array
 */
export const getValuesFromArrayObjects = (data, keys) => {
  const valuesFromKeys = []
  _.each(keys, k => {
    valuesFromKeys.push(_.map(data, row => row[k]))
  })
  return _.uniq(_.flatten(valuesFromKeys))
}

/**
 * Basically converts keys from camel to snake case.
 */
export const convertToApiFormat = (keys = [], values = {}) =>
  keys.reduce((apiVals, key) => {
    return {
      ...apiVals,
      [_.snakeCase(key)]: values[key],
    }
  }, {})

/**
 * Recursively checks a nested object and counts how many properties exist.
 */
export const getNestedObjectPropertiesCount = (obj, count = 0) => {
  for (const key in obj) {
    if (_.isNil(obj[key])) continue
    typeof obj[key] === 'object'
      ? (count = getNestedObjectPropertiesCount(obj[key], count))
      : count++
  }
  return count
}

/**
 * convert Graph Enums to dropdown options
 * example: "EXTERIOR_FRONT" ==> "{ text: Exterior Front", value: "EXTERIOR_FRONT}"
 *
 * DO NOT USE for exception:  "THIRD_PARTY"  =X=> "{ text: "3rd Party", value: "THIRD_PARTY}"
 */
export const convertGraphEnumToOptions = graphEnum =>
  Object.values(graphEnum).map(val => ({
    text: formatTitleCase(val),
    value: val,
  }))
